let cookieWarningBound = false;

export function bindCookieWarning() {
  if (cookieWarningBound) return;
  cookieWarningBound = true;

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('#cookie-warning-close');
    if (!closeButton) return;

    event.preventDefault();
    if (typeof Cookies !== 'undefined') {
      Cookies.set('cookies_accepted', 'true', { expires: 365 * 10 });
    }
    const warning = document.getElementById('cookie-warning');
    if (warning) warning.remove();
  });
}
